<div class="overview-performance">
  <klt-section [title]="title || 'Total return performance'" type="none">
    <div class="graph-box">
      @if (showTimeSelect) {
        <div class="time-select">
          <div class="time-frame">
            @for (time of times; track time) {
              <div
                class="time-frame-item"
                [ngClass]="{ active: currentType === time }"
                (click)="filterPerformance(time)"
              >
                {{ time }}
              </div>
            }
          </div>
        </div>
      }
      <klt-graph
        [loading]="loading"
        [showTimeSelect]="showTimeSelect"
        (filter)="runFilter($event)"
        [options]="options"
        [titles]="titles"
        [height]="height"
      ></klt-graph>
    </div>
  </klt-section>
</div>
